/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TransferDuration } from './TransferDuration';
import {
    TransferDurationFromJSON,
    TransferDurationFromJSONTyped,
    TransferDurationToJSON,
    TransferDurationToJSONTyped,
} from './TransferDuration';

/**
 * 
 * @export
 * @interface TransferPartnerSummary
 */
export interface TransferPartnerSummary {
    /**
     * 
     * @type {string}
     * @memberof TransferPartnerSummary
     */
    hotelChain?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferPartnerSummary
     */
    partner: string;
    /**
     * 
     * @type {number}
     * @memberof TransferPartnerSummary
     */
    partnerPoints: number;
    /**
     * Converted points to hotel points for the current loyalty program
     * @type {number}
     * @memberof TransferPartnerSummary
     */
    convertedPoints: number;
    /**
     * 
     * @type {TransferDuration}
     * @memberof TransferPartnerSummary
     */
    duration: TransferDuration;
    /**
     * Average point redemption value in cents/pt. Compare this to the selected rate to determine if it's worth transferring points.
     * @type {number}
     * @memberof TransferPartnerSummary
     */
    averagePointRedemptionValue: number;
}



/**
 * Check if a given object implements the TransferPartnerSummary interface.
 */
export function instanceOfTransferPartnerSummary(value: object): value is TransferPartnerSummary {
    if (!('partner' in value) || value['partner'] === undefined) return false;
    if (!('partnerPoints' in value) || value['partnerPoints'] === undefined) return false;
    if (!('convertedPoints' in value) || value['convertedPoints'] === undefined) return false;
    if (!('duration' in value) || value['duration'] === undefined) return false;
    if (!('averagePointRedemptionValue' in value) || value['averagePointRedemptionValue'] === undefined) return false;
    return true;
}

export function TransferPartnerSummaryFromJSON(json: any): TransferPartnerSummary {
    return TransferPartnerSummaryFromJSONTyped(json, false);
}

export function TransferPartnerSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransferPartnerSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'hotelChain': json['hotel_chain'] == null ? undefined : json['hotel_chain'],
        'partner': json['partner'],
        'partnerPoints': json['partner_points'],
        'convertedPoints': json['converted_points'],
        'duration': TransferDurationFromJSON(json['duration']),
        'averagePointRedemptionValue': json['average_point_redemption_value'],
    };
}

export function TransferPartnerSummaryToJSON(json: any): TransferPartnerSummary {
    return TransferPartnerSummaryToJSONTyped(json, false);
}

export function TransferPartnerSummaryToJSONTyped(value?: TransferPartnerSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hotel_chain': value['hotelChain'],
        'partner': value['partner'],
        'partner_points': value['partnerPoints'],
        'converted_points': value['convertedPoints'],
        'duration': TransferDurationToJSON(value['duration']),
        'average_point_redemption_value': value['averagePointRedemptionValue'],
    };
}

